import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var COMMON_DEFAULT_STYLES = {
  border: {
    value: '0'
  },
  outlineStyle: 'none',
  width: '100%',
  placeholderFontStyle: 'italic',
  placeholderTextColor: 'base.subtle',
  textVariant: 'body-default'
};
var READ_ONLY_DEFAULT_STYLES = {
  backgroundColor: 'state.disabled',
  borderColor: 'state.disabled'
};
var DISABLED_DEFAULT_STYLES = _objectSpread(_objectSpread({}, READ_ONLY_DEFAULT_STYLES), {}, {
  cursor: 'not-allowed',
  placeholderTextColor: 'state.disabled',
  textColor: 'state.disabled'
});

export { COMMON_DEFAULT_STYLES, DISABLED_DEFAULT_STYLES, READ_ONLY_DEFAULT_STYLES };
//# sourceMappingURL=constants.js.map
